import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import './NotFoundPage.css';

/**
 * 404 Not Found Page
 */
export function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page Not Found - Peptide Finder"
        description="The page you are looking for could not be found."
      />
      <div className="not-found-page">
        <div className="not-found-page-container">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>The page you are looking for could not be found.</p>
          <Link to="/" className="not-found-page-link">
            Go to Home Page
          </Link>
        </div>
      </div>
    </>
  );
}

